module.exports = __webpack_public_path__ + "static/media/Smiley_neutral.e5ab260f.png";